import { render, staticRenderFns } from "./ResellerServiceSelector.vue?vue&type=template&id=63cb025a"
import script from "./ResellerServiceSelector.vue?vue&type=script&lang=js"
export * from "./ResellerServiceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports